export const BOOKKEEPING_WAITLIST_STATES = [
  "lead",
  "interested_pre_call",
  "interested_call_pending",
  "eligible",
  "onboarded",
  "not_eligible",
] as const;

export type BookkeepingWaitlistState = (typeof BOOKKEEPING_WAITLIST_STATES)[number];

export type BooksManagementValue = "self_managed" | "external_bookkeeper" | "accounting_firm" | "not_up_to_date";

export interface WaitlistEntryOut {
  id: number;
  companyId: number;
  state: BookkeepingWaitlistState;
  createdAt: string;
  updatedAt: string;
}

export interface WaitlistEntryCreatePayload {
  mostRecentTaxYearFiled: number;
  booksManagement: BooksManagementValue;
}

export interface WaitlistEntryErrorBody {
  message: string;
}
